import { createFileRoute } from "@tanstack/react-router";
import z from "zod";

export const RouteSearchParams = z.object({
  page: z.coerce.number().min(0).optional().default(0),
});

export const Route = createFileRoute("/reimbursements/list")({
  validateSearch: RouteSearchParams,
});
